<template>
  <div>
    <div>
      <el-table ref="sortTable" :data="data" :cell-style="rowStyle" :summary-method="getSummaries" show-summary
        style="width: 93%;margin-left: 170px; overflow: none;" class="copy" @sort-change="sortChangeEvt">
        <el-table-column prop="staff" label="姓名" width="100" sortable :sort-orders="orders"></el-table-column>
        <el-table-column prop="department_id" width="100" label="部门" sortable :sort-orders="orders"></el-table-column>
        <el-table-column prop="average" width="100" label="平均分" sortable :sort-orders="orders"></el-table-column>
        <el-table-column prop="total_score" width="100" label="总分" sortable :sort-orders="orders"></el-table-column>
        <el-table-column prop="count" label="评分图次" width="100" sortable :sort-orders="orders"></el-table-column>
        <!-- 图量 -->
        <el-table-column prop="total" width="100" label="图量" sortable :sort-orders="orders"></el-table-column>
        <el-table-column v-for="(item)  in data[0].user" :sort-orders="orders" width="100" :key="item.id"
          v-if="userRole != 5 && userRole != 3 && userRole != 4" :prop="item.id.toString() " :label="item.realname"
          sortable="custom">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.user.find(u => u.id === item.id).score == '0' ? '#f5f5f5' : '#000' }">
              {{ scope.row.user.find(u => u.id === item.id).score }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="userRole == 5 || userRole == 3 || userRole == 4">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>


<script>
export default {
  props: ["data", "num", "user", 'avg'],

  data() {
    return {
      orders: ['descending', 'ascending', null],
      //分页输入框数据
      paginationInput: 10,
      currentPage1: 1,
      //分页总数据
      total: 100,
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const current = new Date();
              let nowDayOfWeek = current.getDay();
              if (nowDayOfWeek === 0) nowDayOfWeek = 7;
              const dayNum = 1 * 24 * 60 * 60 * 1000;
              const firstDate = new Date(current.valueOf() - (nowDayOfWeek - 1) * dayNum);
              const lastDate = new Date(new Date(firstDate).valueOf() + 6 * dayNum);
              picker.$emit("pick", [firstDate, lastDate]);
            },
          },
          {
            text: "当月",
            onClick(picker) {
              const date = new Date();
              const year = date.getFullYear();
              const month = date.getMonth();
              let thisMonthStartDate = new Date(year, month, 1);
              let thisMonthEndDate = new Date(year, month + 1, 0);
              picker.$emit("pick", [thisMonthStartDate, thisMonthEndDate]);
            },
          },
          {
            text: "当年",
            onClick(picker) {
              var tYear = new Date().getFullYear();
              var startTime = new Date(tYear, 0, 1); //当前年第一天
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, start]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              const current = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000);
              let nowDayOfWeek = current.getDay();
              let diffToMonday =
                current.getDate() - nowDayOfWeek + (nowDayOfWeek === 0 ? -6 : 1);
              const firstDate = new Date(current.setDate(diffToMonday));
              const lastDate = new Date(current.setDate(diffToMonday + 6));
              picker.$emit("pick", [firstDate, lastDate]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              var now = new Date();
              var fd = new Date(now.getFullYear(), now.getMonth() - 1, 1);
              var ed = new Date(now.getFullYear(), now.getMonth(), 0);
              picker.$emit("pick", [fd, ed]);
            },
          },
          {
            text: "去年",
            onClick(picker) {
              var tYear = new Date().getFullYear() - 1;
              var startTime = new Date(tYear, 0, 1);
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            },
          },
        ],
      },
      value2: "",
      input: "",
      editShowInp: null,
      userRole:null,
    };
  },
  created() {
    // role字段 6管理员 3市场 4助理   5组长
    this.userRole = localStorage.getItem('role');

   },
  mounted(){
    // 获取data的全部内容
  },
  methods: {
    clearContent() {

    },
    clearSort() {
        this.$refs.sortTable.clearSort();
    },
    cleanUpEvt() { },
    limitEvt() { },

    handleCurrentChange() { },
    //
    rowStyle({ row, column, rowIndex, columnIndex }) {
    },
    //列表排序
    sortChangeEvt(row) {
      if (row.column.id.split('_').pop() < 6) {
        return; // 如果点击的列在"el-table_1_column_6"之前，则直接返回，不执行排序逻辑
      }
      this.$parent.status = '';
      let a = {
        orWhere: row.prop,
      }
      if (row.order === 'ascending') {
        a.order = 'asc';
      } else if (row.order === 'descending') {
        a.order = 'desc';
      }
      this.$emit('Min_BOX', a)
    },

    editInpBlurEvt() {
      this.editShowInp = null;
    },


    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];


      columns.forEach((column, index) => {
        if (index === 2) {
          sums[index] = this.avg.average;
        }
        if (index === 3) {
          sums[index] = this.avg.score_count;
        }
        if (index === 4) {
          sums[index] = this.avg.count;
        }
        // for (let key in this.user) {
        //   if (column.property == this.user[key].id) {
        //     sums[index] = this.user[key].score;
        //   }
        // }

      });
      return sums.map(value => value === 0 ? '' : value);
    },

  },
};
</script>

<style lang="less" scoped>

/deep/ .el-table__footer-wrapper {
  position: fixed;
  top: 145px;
  z-index: 111;
  height: 49px;
  background-color: #fff;
  width: calc(100% - 178px);
}

/deep/tbody .project_Free .cell {
  background-color: #f5f5f5 !important;
}

/deep/.el-table__header-wrapper tbody tr .project_Free {
  background: #fff !important;
}

@media screen and (min-width: 0px) and (max-width: 1824px) {
  .edit {
    width: 100%;
    min-width: 1200px;
    display: flex !important;
    flex-wrap: wrap;

  }

  .edit .el-input {
    width: 137px !important;
    display: block;
  }

  .span_box {
    top: 115px !important;
  }

  /deep/.el-table__footer-wrapper {
    position: fixed;
    top: 180px !important;
    z-index: 111;
    height: 49px;
    background-color: #fff;
    width: calc(100% - 178px);
  }

  /deep/.el-table__body-wrapper {
    // overflow: auto !important;
    height: calc(100vh - 275px) !important;
  }

  /deep/.el-table__fixed-body-wrapper {
    overflow-y: scroll !important;
    height: calc(100vh - 295px) !important;
  }

  .span_box {
    height: 40px !important;
  }

  /deep/.el-table--fit {
    margin-top: 35px;
  }

  /deep/.el-table__fixed {
    height: calc(100% - 16px) !important;
  }

}

@media screen and (min-width: 1825px) and (max-width: 1920px) {

  .copy {
    top: 195px !important;
    width: 91% !important;
    overflow: auto !important;
  }

  /deep/.el-table__footer-wrapper {
    position: fixed;
    top: 185px !important;
    z-index: 111;
    height: 49px;
    background-color: #fff;
    width: calc(100% - 178px);
  }

  /deep/.el-table__body-wrapper {
    overflow-y: auto !important;
    height: calc(100vh - 290px) !important;
  }

  /deep/.el-table__fixed-body-wrapper {
    overflow-y: scroll !important;
    height: calc(100vh - 275px) !important;
  }

  .span_box {
    height: 35px !important;
  }

  /deep/.el-table--fit {
    margin-top: 35px;
  }

  /deep/.el-table__fixed {
    height: calc(100% - 5px) !important;
  }

  .content /deep/.el-table--fit {
    margin-top: 10px !important;
  }

}

@media screen and (min-width: 1921px) and (max-width: 2154px) {


  .copy {
    top: 175px !important;
    width: 93.5% !important;
    overflow: auto !important;
  }

  /deep/.el-table__body-wrapper {
    overflow: scroll !important;
    height: calc(100vh - 265px) !important;
  }

  /deep/.el-table__fixed-body-wrapper {
    overflow-y: scroll !important;
    height: calc(100vh - 255px) !important;
  }

  /deep/.el-table--fit {
    margin-top: 35px;
  }

  /deep/.el-table__fixed {
    height: calc(100% - 0px) !important;
  }

  .content /deep/.el-table--fit {
    margin-top: 10px !important;
  }
}

@media screen and (min-width: 2153px) and (max-width: 2560px) {
  .copy {
    top: 175px !important;
    width: 93.5% !important;
    overflow: auto !important;
  }

  /deep/.el-table__body-wrapper {
    overflow: scroll !important;
    height: calc(100vh - 265px) !important;
  }

  /deep/.el-table__fixed-body-wrapper {
    overflow-y: scroll !important;
    height: calc(100vh - 255px) !important;
  }

  /deep/.el-table--fit {
    margin-top: 35px;
  }

  /deep/.el-table__fixed {
    height: calc(100% - 5px) !important;
  }

  .content /deep/.el-table--fit {
    margin-top: 10px !important;
  }
}

@media screen and (min-width: 2561px) and (max-width: 3000px) {
  .copy {
    top: 175px !important;
    width: 95% !important;
    overflow: auto !important;
  }

  /deep/.el-table__footer-wrapper {
    position: fixed;
    top: 185px !important;
    z-index: 111;
    height: 49px;
    background-color: #fff;
    width: calc(100% - 178px);
  }

  /deep/.el-table__footer-wrapper {
    top: 145px !important;
  }

  /deep/.el-table__body-wrapper {
    min-height: calc(100vh - 21vh);
    max-height: calc(100vh - 22vh);
    overflow: auto !important;
  }

  /deep/.el-table--fit {
    margin-top: 35px;
  }

  /deep/.el-table__fixed-body-wrapper {
    overflow-y: scroll !important;
    height: calc(100vh - 337px) !important;
  }

  .content /deep/.el-table--fit {
    margin-top: 10px !important;
  }

}

@media screen and (min-width: 3001px) and (max-width: 3440px) {
  .copy {
    top: 175px !important;
    width: 95% !important;
    overflow: auto !important;
  }

  /deep/.el-table__footer-wrapper {
    position: fixed;
    top: 185px !important;
    z-index: 111;
    height: 49px;
    background-color: #fff;
    width: calc(100% - 178px);
  }

  /deep/.el-table__footer-wrapper {
    top: 145px !important;
  }

  /deep/.el-table__body-wrapper {
    min-height: calc(100vh - 21vh);
    max-height: calc(100vh - 22vh);
    overflow: auto !important;
  }

  /deep/.el-table--fit {
    margin-top: 35px;
  }

  /deep/.el-table__fixed-body-wrapper {
    overflow-y: scroll !important;
    height: calc(100vh - 260px) !important;
  }

  .content /deep/.el-table--fit {
    margin-top: 30px !important;
  }

  .content /deep/ .el-table__body-wrapper {
    min-height: calc(100vh - 55vh) !important;
    max-height: calc(100vh - 58vh) !important;
  }
}

@media screen and (min-width: 3441px) and (max-width: 3840px) {
  .copy {
    top: 175px !important;
    width: 95.5% !important;
    overflow: auto !important;
  }

  /deep/.el-table__footer-wrapper {
    position: fixed;
    top: 185px !important;
    z-index: 111;
    height: 49px;
    background-color: #fff;
    width: calc(100% - 178px);
  }

  /deep/.el-table__footer-wrapper {
    top: 145px !important;
  }

  /deep/.el-table__body-wrapper {
    min-height: calc(100vh - 14vh);
    max-height: calc(100vh - 22vh);
    overflow: auto !important;
  }

  /deep/.el-table__fixed-body-wrapper {
    height: 100%;
    min-height: 1710px !important;
  }

  /deep/.el-table--fit {
    margin-top: 35px;
  }

  /deep/.el-table__fixed {
    height: calc(100% - 16px) !important;
  }

  .content /deep/.el-table--fit {
    margin-top: 40px !important;
  }

  .content /deep/ .el-table__body-wrapper {
    min-height: calc(100vh - 72vh) !important;
    max-height: calc(100vh - 73vh) !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/copy.vue